import useLanguage from "hooks/i18n";
import { useTranslation } from "react-i18next";
import Break from "./presentational";

const StartTrialBreak = ({ advertisingView, darkMode }) => {
    const [language] = useLanguage();
    const [t] = useTranslation('global');

    const sendDemoEvent = () => {
        window.ga('send', 'event', 'button', 'click_button', 'free_demo')
    }

    return (
        <Break
            t={t}
            language={language}
            sendDemoEvent={sendDemoEvent}
            advertisingView={advertisingView}
            darkMode={darkMode}
        />
    );
}

export default StartTrialBreak;